import * as HttpService from './http';
import { store } from '../state/store';
import { apiConnectorMethods } from 'api/api.config';
import { SERVER_URLS, PARTIAL_URL, RECAPTCHA_CLIENT_SECRET } from 'constants/api.constants';
import { globalEnvironment } from 'constants/global.constants';
import _ from 'lodash';

const getToken = () => {
	return `Bearer ${store.getState().auth.token}`;
};

export default class ApiService {
	static instance: ApiService;
	static baseUrl = '';

	constructor() {
		if (ApiService.instance) {
			return ApiService.instance;
		}
		this.init();
		ApiService.instance = this;
	}

	static getInstance = () => ApiService.instance || new ApiService();

	init = async () => {
		ApiService.baseUrl = `${SERVER_URLS[globalEnvironment]}${PARTIAL_URL}`;
		await HttpService.init(
			apiConnectorMethods,
			ApiService.baseUrl,
			getToken,
			RECAPTCHA_CLIENT_SECRET[globalEnvironment]
		);
	};

	execute = async (
		name: string,
		data?: Record<string, any>,
		additionalHeaders?: Record<string, string>,
		additionalConfiguration?: Record<string, string>
	): Promise<any> => {
		return await HttpService.exec(name, data ?? {}, additionalHeaders ?? {}, additionalConfiguration ?? {});
	};
}
